import { FC } from "react";
import { MainListItemStyled } from "@/shared";

export const InvestmentsListNoData: FC = () => {
  return <MainListItemStyled>No investments</MainListItemStyled>;
};
